module.exports = __webpack_public_path__ + "media/img/home/img_thumb-1-d5ee65a66424151be8188754d3fd6b74.png";